import { Tooltip } from "@edgetier/components";
import { useIsOverflowed } from "@edgetier/utilities";
import classNames from "classnames";
import { FunctionComponent, isValidElement, memo, useRef } from "react";

import "./page-header.scss";
import { IProps } from "./page-header.types";

/**
 * Header with title above a page's content.
 * @param props.className   An optional additional class name to be applied to the header.
 * @param props.title       Name of the page.
 * @param props.subTitle    Optional subtitle.
 * @param props.children    Optional additional content to be displayed in the header.
 */
const PageHeader: FunctionComponent<IProps> = ({ className, children, title, subTitle }) => {
    const titleRef = useRef(null);
    const isOverflowed = useIsOverflowed(titleRef);
    return (
        <div className={classNames("page-header", className)}>
            <div className="page-header__title">
                {typeof title === "string" ? (
                    <Tooltip content={title} disableTooltip={!isOverflowed} placement="bottom-center">
                        <h2 ref={titleRef}>{title}</h2>
                    </Tooltip>
                ) : isValidElement(title) ? (
                    title
                ) : undefined}
                {subTitle && <h3>{subTitle}</h3>}
            </div>
            {children}
        </div>
    );
};

export default memo(PageHeader);
